import React from "react";
import { Grid } from "react-loader-spinner";

function Loader() {
  return (
    <div
      style={{
        height: "90vh",
        margin: "auto",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}>
      <Grid ariaLabel="loading-indicator" />
    </div>
  );
}

export default Loader;
